import { Client } from "@colyseus/sdk";

/** Same-origin by default (Vite proxies /matchmake + websocket in dev; the server serves the client in prod). */
export const client = new Client(import.meta.env.VITE_SERVER_URL ?? window.location.origin);
